<template>
  <b-card style="height: 100%">
    <b-card-header class="p-0 pb-2">
      <b-card-title>آخرین پرسش و پاسخ ها</b-card-title>
    </b-card-header>
    <div class="d-flex px-0 flex-wrap align-items-center">
      <b-form-group
        label="فیلتر بر اساس"
        class="mb-1 col-12 col-sm-4 pr-md-2 pr-sm-50 px-0"
      >
        <select-box
          v-model="auditable_type"
          label="text"
          class="w-100"
          select="val"
          :lists="types"
          searchable
        />
      </b-form-group>
      <b-form-group
        v-if="auditable_type"
        class="mb-1 col-12 col-sm-8 pr-md-2 px-0"
        label="انتخاب شناسه"
      >
        <select-box
          v-model="auditable_id"
          label="text"
          class="w-100"
          select="id"
          :url="auditable_type"
          searchable
        />
      </b-form-group>
    </div>

    <data-table :fields="fields" :items="faqs" :loading="loading">
      >
      <template #status="{ data }">
        <b-badge :variant="data.item.active ? 'light-success' : 'light-danger'"
          >{{ data.item.active ? "فعال" : "غیر فعال" }}
        </b-badge></template
      >

      <template #model="{ data }">
        <div style="white-space: nowrap">
          {{
            (data.item.model_type == "course"
              ? "دوره :"
              : data.item.model_type == "semester"
              ? "ترم :"
              : "جلسه :") +
              " " +
              data.item.model.name || "-"
          }}
        </div>
      </template>
      <template #detail="{ data }">
        <b-button
          size="sm"
          variant="flat-secondary"
          @click="data.toggleDetails"
        >
          <span class="ml-50"> جزییات</span>
        </b-button></template
      >

      <template #row-details="{ data }">
        <div class="d-flex flex-column">
          <div class="d-flex flex-wrap mb-1">
            <span>سوال : </span><span>{{ data.item.question }}</span>
          </div>
          <div class="d-flex flex-wrap">
            <span>جواب : </span><span>{{ data.item.answer }}</span>
          </div>
        </div>
      </template>
    </data-table>

    <div
      class="w-100 d-flex flex-wrap justify-content-between align-items-center"
    >
      <div
        class="col-md-12 d-flex justify-content-md-center align-items-center"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="md"
          class="mt-2 mb-0 d-flex justify-content-center"
        ></b-pagination>
      </div>
      <!-- <b-form
        @submit.prevent="goTo"
        class="d-flex col-md-3 align-items-center justify-content-md-end pr-0"
      >
        <div>
          <b-button type="submit" size="sm" variant="primary"
            >رفتن به
          </b-button>
        </div>
        <b-form-group label-for="to-page" class="w-50 ml-50 mb-0">
          <b-form-input
            id="to-page"
            type="number"
            size="sm"
            :max="pagination.total_pages"
            min="1"
            v-model="choosenPage"
          />
        </b-form-group>
      </b-form> -->
    </div>
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BBadge,
  BPagination,
  BLink,
  BCard,
  BAvatar,
  BFormCheckbox,
  BForm,
  BFormInput,
  BFormGroup,
  BCardHeader,
  BCardTitle,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import qs from "qs";
export default {
  components: {
    DataTable,
    BButton,
    BModal,
    BCard,
    VBModal,
    BBadge,
    BPagination,
    BLink,
    BAvatar,
    BFormCheckbox,
    BForm,
    BFormInput,
    BFormGroup,
    SelectBox,
    BCardHeader,
    BCardTitle,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      choosenPage: 1,

      selectAll: false,
      removeFaqsData: [],
      faqs: [],
      loading: false,
      url: "/panel/faqs",
      currentPage: 1,
      pagination: {},
      visible: false,
      search: "",
      types: [
        {
          id: 1,
          text: "دوره",
          val: "course",
        },
        {
          id: 2,
          text: "جلسه",
          val: "session",
        },
      ],
      auditable_type: "",
      auditable_id: "",

      fields: [
        { key: "model", label: "مربوط به" },
        { key: "detail", label: "" },
      ],
       
    };
  },
  watch: {
    currentPage(val) {
      this.getFaqs(val);
    },
    auditable_type(val) {
      this.auditable_id = "";
    },
    auditable_id(val) {
      if (this.auditable_type == null) {
        this.getFaqs();
      }
      if (this.auditable_type && val) {
        this.getFaqs();
      }
    },
  },
  created() {
    this.getFaqs();
  },

  methods: {
    async getFaqs(page) {
      this.loading = true;
      try {
        let filters = {};
        this.auditable_type &&
          this.auditable_id &&
          (filters.model = {
            type: this.auditable_type,
            id: this.auditable_id,
          }); 
        const { data } = await this.$http.get(this.url, {
           params: {
           includes: ["model"],
            per_page: 8,
            page: page || 1,
            filters: {
              ...filters,
            },
          },
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.faqs = data.data.faqs;
        this.pagination = data.data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
